import $ from 'jquery';
import React, { useState, useEffect, useContext, useRef } from 'react';
import SessionManager from './../../routes/SessionManager';
import PDFAnnotate from './../../components/PDFAnnotate';
import SiteWeather from "./../../components/dashboard/SiteWeather";
import bootbox from 'bootbox';
import { Select } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { Context } from '../../views/app';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function DashboardSiteMap() {
    let appContext = useContext(Context);
    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let isMount = useRef(true);
    user.default_dashboard = 'Site Map';
    sessionMgr.storeCookie('user', user);


    const [fileError, setFileError] = useState(null);
    const [zones, setZones] = useState([]);
    const [siteplans, setSiteplans] = useState([]);
    const [site_locations, setSite_locations] = useState([]);
    const [defaultSelected, setDefaultSelected] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [remoteSensors, setRemoteSensors] = useState([]);
    const [headlessGateways, setHeadlessGateways] = useState([]);
    const [allLocations, setAllLocations] = useState([]);
    const [site_selected, setSite_selected] = useState(user.site_selected ? user.site_selected : null);
    const [sensors_info, setSensors_info] = useState([]);

    useEffect(() => {
        if (user.site_locations && user.site_locations.length > 0) {
            setSite_locations(user.site_locations);
        } else {
            fetchSiteLocations();
        }
        return () => isMount.current = false;
    }, []);

    useEffect(() => {
        if (site_locations.length > 0) {
            if (user.site_locations && user.site_locations.length > 0) {
                let siteDefault = getDefaultSite(user.site_locations);
                fetchSiteLocationZones(siteDefault);
            } else {
                let siteDefault = getDefaultSite(site_locations);
                user.site_locations = site_locations;
                sessionMgr.storeCookie('user', user);
                fetchSiteLocationZones(siteDefault);
                // fetchSiteLocationGatewaySensors();
            }
        }
    }, [site_locations]);

    useEffect(() => {
        fetchSitePlans(user.site_selected);
        fetchSiteLocationGatewaySensors();
    }, [allLocations]);

    useEffect(() => {
        if (zones.length > 0) {
            user.zones = [...zones];
            user.site_locations = site_locations;
            sessionMgr.storeCookie('user', user);
            fetchSiteLocationSensors();
            // fetchSiteLocationGatewaySensors();
        }
    }, [zones]);

    const fetchSiteLocations = () => {
        var data = {
            customer_id: user.site_selected.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }
        CommonUtils.ajax(
            {
                url: API.SITE.BASE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state !== 'Inactive') : [];
                    let loc = 'site_name';
                    site_locations = site_locations.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);
                    setSite_locations(site_locations);
                }
            },
            (res) => {

            });
    }

    const getDefaultSite = (site_locations) => {
        var siteDefault = null;
        let defaultSiteId = user.site_id;
        if (user.site_selected)
            defaultSiteId = user.site_selected.site_id;
        if (defaultSiteId) {
            for (let s of site_locations)
                if (s.site_id + '' === defaultSiteId + '') {
                    siteDefault = s;
                    break;
                }
        }

        if (!siteDefault)
            siteDefault = site_locations[0];
        return siteDefault;
    }

    const fetchSiteLocationZones = (siteSelected, confirmed = false, refresh = false) => {
        if (confirmed !== true && $('#siteplan-save').length > 0) {
            bootbox.confirm({
                message: 'Would you like to save siteplan before you move on ?', buttons: {
                    confirm: {
                        label: 'Yes, Please ...'
                    },
                    cancel: {
                        label: 'No'
                    }
                }, callback: (isYes) => {
                    if (isYes) {
                        $('#siteplan-save').trigger('click');
                    } else {
                        fetchSiteLocationZones(siteSelected, true);
                    }
                }
            });

            return false;
        }

        setFileError(null);
        setDefaultSelected(null);
        setSite_selected(siteSelected);
        setZones([]);
        setSiteplans([]);

        if (!user.site_selected || (siteSelected && siteSelected.site_id !== user.site_selected.site_id)) {
            user.site_selected = siteSelected;
            delete user.siteplan_selected;
            return appContext.updateUser(user);
        }

        if (!user["zone_prefs_for_sites"]) {
            user["zone_prefs_for_sites"] = {};
            if (user.user_sites && user.user_sites.length) {
                for (var index = 0; index < user.user_sites.length; index++) {
                    var user_site = user.user_sites[index];
                    user["zone_prefs_for_sites"][user_site] = user.zone_prefs;
                }
            }
        }

        var data = {
            customer_id: user.site_selected.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        CommonUtils.ajax(
            {
                url: API.LOCATION.BASE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    var allLocations = res.data;
                    let zone_prefs = user.zone_prefs_for_sites && user.zone_prefs_for_sites[user.site_selected.site_id];

                    var filteredZones = (res.data).filter(zone => zone.location_adminstatus === "Up");
                    if (zone_prefs && zone_prefs.length > 0) {
                        var sortedZones = filteredZones.sort((a, b) => {
                            return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                        });
                    } else {
                        sortedZones = filteredZones;
                    }

                    //User accessible zones only.
                    let user_zones = user.user_zones;
                    if (user_zones && user_zones[siteSelected.site_id]) {
                        let zonesAllowed = user_zones[siteSelected.site_id];
                        if (zonesAllowed.length > 0) {
                            let sortedZonesFinal = [];
                            for (let s of sortedZones) {
                                if (zonesAllowed.includes(s.location_id)) {
                                    sortedZonesFinal.push(s);
                                }
                            }
                            sortedZones = sortedZonesFinal;
                        }
                    }
                    if (isMount.current) {
                        setZones(sortedZones);
                        setAllLocations(allLocations);
                    }
                } else {
                    user.zones = [];
                    sessionMgr.storeCookie('user', user);
                    if (isMount.current) {
                        fetchSitePlans(siteSelected);
                    }
                }

            },
            (res) => {

            });
    }

    const refreshSitesPlans = () => {
        fetchSitePlans(user.site_selected);
    }

    const fetchSitePlans = (siteSelected) => {

        setRefreshing(true);
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: siteSelected && siteSelected.site_id,
            customer_id: siteSelected && siteSelected.customer_id,
            expires: 60 * 60 * 24 * 7,
            is_enabled: true
        };

        CommonUtils.ajax({
            url: API.DOC_VAULT.FETCH,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
        }).then((response, error) => {
            if (response && response.status && response.status.code === 200) {
                let uploadedFiles = response.data;
                let siteplanSelectedTemp = user.siteplan_selected;
                let siteplanSelected = null;

                let siteplansEnabled = uploadedFiles.filter((rec) => {
                    if (rec.is_enabled) {
                        if (siteplanSelectedTemp && siteplanSelectedTemp.file_ref === rec.file_ref) {
                            siteplanSelected = { ...rec };
                        }
                    }
                    return rec.is_enabled;
                });

                if (siteplansEnabled.length > 0) {
                    if (!siteplanSelected)
                        siteplanSelected = siteplansEnabled[0];

                    let user = sessionMgr.readCookie('user');
                    user.siteplan_selected = siteplanSelected;
                    sessionMgr.storeCookie('user', user);
                    if (isMount.current) {
                        setRefreshing(false);
                        setSiteplans(siteplansEnabled);
                        setDefaultSelected(siteplanSelected);
                    }
                } else {
                    if (isMount.current) {
                        setRefreshing(false);
                        setFileError('No Active Site Plans Found ...');
                    }
                }
            }
            // else {
            //     setRefreshing(false);
            //     setFileError('Error Occured...');
            // }
        })
    }

    const onSelectePDF = (siteplanSelected) => {
        user.siteplan_selected = siteplanSelected;
        sessionMgr.storeCookie('user', JSON.parse(JSON.stringify(user)));
        setFileError(null);
        setDefaultSelected(siteplanSelected);
    }

    const fetchSiteLocationSensors = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "D",
            criteria: {
                from: 0,
                size: 1000,
                sensor_site_id: user.site_selected ? user.site_selected.site_id : site_selected
            }
        }

        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.REMOTE_SENSOR.FETCH,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    var remoteSensors = []
                    for (var record of res.data.records) {
                        var currentRecord = {};
                        currentRecord.s_id = record.sensor_id;
                        if (record.sensor_name.trim() === "") {
                            currentRecord.serial_number = record.sensor_serial_number;
                            currentRecord.name = record.sensor_name.trim() || record.sensor_serial_number;
                            currentRecord.device_type = 'sensor';
                            currentRecord.sensor_type = record.sensor_type
                        } else {
                            currentRecord.name = record.sensor_name;
                            currentRecord.device_type = 'sensor';
                            currentRecord.sensor_type = record.sensor_type;
                        }
                        currentRecord.sensor_dev_timestamp = record.sensor_dev_timestamp;
                        remoteSensors.push(currentRecord);
                    }
                    if (isMount.current) {
                        setSensors_info(res.data.records);
                        setRemoteSensors(remoteSensors);
                    }
                }
            }
        )
    }

    const fetchSiteLocationGatewaySensors = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "M",
            criteria: {
                from: 0,
                size: 1000,
                site_id: user.site_selected ? user.site_selected.site_id : site_selected,
                advanced_filter: JSON.stringify([
                    { attribute: 'device_id', value: "B%", operator: 'like' }
                ]),
            }
        }

        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.DEVICE.FETCH,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var headless_Gateways = [];
                    res.data.records.forEach(rec => {
                        var currentRecord = {};
                        currentRecord.s_id = rec.record.device_id;
                        currentRecord.device_type = rec.record.device_type;
                        currentRecord.location_id = rec.record.location_id;
                        currentRecord.device_operstatus = rec.record.device_operstatus;
                        currentRecord.name = allLocations.find(loc => loc.location_id === rec.record.location_id) && allLocations.find(loc => loc.location_id === rec.record.location_id).location_name;
                        if (currentRecord.device_type !== "Axis") {
                            headless_Gateways.push(currentRecord);
                        }
                    })
                    if (isMount.current) {
                        setHeadlessGateways(headless_Gateways);
                    }
                }
            }
        )
    }

    const mergedSensors = remoteSensors.concat(headlessGateways);
    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row mb-4 px-0">
                    <div className={"col-md-4 px-md-0 mb-2"} style={{ lineHeight: '24px' }}>
                        <Select
                            style={{ width: '200px' }}
                            className='font-size-13 w-175 site_picker'
                            dropdownMatchSelectWidth={false}
                            filterOption={(input, option) =>
                                (option.label).toLowerCase().includes(input.toLowerCase())
                            }
                            showSearch
                            value={site_selected && site_selected.site_id}
                            onChange={(...args) => {
                                fetchSiteLocationZones(args[1].site, false);
                            }}
                            options={site_locations && site_locations.map((a) => { return { value: a.site_id, label: a.site_name + ', ' + a.site_city, site: a }; })}
                            placeholder="Choose Site"
                        />
                    </div>
                    <div className={"col-md-4 mb-2 text-md-center"}>
                        {user.site_selected && site_selected &&
                            <div className="bg-white border-rounded font-size-12 py-custom">
                                <SiteWeather site={site_selected}></SiteWeather>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 px-md-0 mb-2 text-md-right">
                        <div className="d-inline-flex align-items-center bg-white" style={{ paddingLeft: "4px", lineHeight: "24px" }}>
                            <FilePdfOutlined style={{ color: '#7c3aed', fontSize: '18px' }} />
                            <Select
                                style={{ width: '200px' }}
                                className='font-size-13 pdf-selector'
                                dropdownMatchSelectWidth={false}
                                filterOption={(input, option) =>
                                    (option.label).toLowerCase().includes(input.toLowerCase())
                                }
                                showSearch
                                bordered={false}
                                value={defaultSelected ? defaultSelected.file_name : undefined}
                                placeholder={refreshing ? 'Loading...' : 'No Active Site Plans Found...'}
                                onChange={(value, option) => {
                                    onSelectePDF(option.plan);
                                }}
                                options={siteplans && siteplans.map((plan) => {
                                    return {
                                        value: plan.file_name,
                                        label: plan.file_name,
                                        plan: plan
                                    };
                                })}
                            />
                        </div>
                    </div>
                    <div
                        id="pdf-highlighter-container"
                        style={{
                            height: "100vh",
                            width: "100%",
                            marginTop: "40px",
                            background: "white",
                            position: "relative"
                        }}
                    >
                        {!refreshing && defaultSelected &&
                            <PDFAnnotate
                                timestamp={Math.floor(Math.random() * 100000000000) + 1}
                                refresh={refreshSitesPlans}
                                zones={zones}
                                sensors={mergedSensors}
                                sensors_info={sensors_info}
                                siteplan={JSON.parse(JSON.stringify(defaultSelected))}
                            >
                            </PDFAnnotate>
                        }
                        {fileError &&
                            <div className="m-2">
                                {fileError}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default DashboardSiteMap;